import React, { Component } from "react";
import TreeView from "@zippytech/react-toolkit/TreeView";
import "@zippytech/react-toolkit/TreeView/index.css";
import MenuNode from "./MenuNode";
import { dispatch } from "@rematch/core";
import { Icon } from "semantic-ui-react";
import { toastr } from 'react-redux-toastr';

import { Container } from 'react-smooth-dnd'
import AddPhase from '../../modals/AddPhaseModal'
import AddActivity from '../../../Drive/modals/AddActivityModal';

const colors = require('./../../../../../common/color.json');
let treeData = [];
let selectDepth
class PracticeFlowTreePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      setEditMode: false,
      lastClicked: 0,
      resourcePaneOpen: true
    };
    this.addDependency = this.addDependency.bind(this);
    this.inputValidation = this.inputValidation.bind(this);
    this.handlePeer = this.handlePeer.bind(this);
    this.filterColor = this.filterColor.bind(this);

  }


  onSelectionChange(selectedMap) {
    dispatch.app.setCollapsedResourcePaneIndexTemp(null)
    if (selectedMap.node.label.props.id) {
      selectDepth = selectedMap.depth
      if (this.props.setUniqueId === selectedMap.node.label.props.id) {
        if (this.state.lastClicked + 1000 < new Date().getTime()) {
          this.setState({ setEditMode: true, lastClicked: new Date().getTime() });
          dispatch.initiatives.showResourecePane(null);
        } else {
          if (this.state.resourcePaneOpen) {
            dispatch.initiatives.showResourecePane("ConfigureActivities");
            dispatch.initiatives.splitAt("60%");
            this.setState({
              resourcePaneOpen: false
            })
          } else {
            dispatch.initiatives.showResourecePane("ConfigureActivities");
            dispatch.initiatives.splitAt("60%");
            this.setState({
              resourcePaneOpen: true
            })
          }
          this.setState({ lastClicked: new Date().getTime(), setEditMode: false });
        }
      }
      else {
        this.setState({ setEditMode: false, lastClicked: new Date().getTime(), resourcePaneOpen: true });
        this.props.getSelection(selectedMap.node.label.props.id);
      }

      if (this.props.selectedDataById.status === 4) {
        dispatch.lifeCycle.disableLinking();
        dispatch.lifeCycle.setDependencyIcon(false);
      } else {
        dispatch.lifeCycle.enableLinking();
      }

      dispatch.initiatives.setIdToCenterPosition(selectedMap.node.label.props.id);
    }

    else {
      dispatch.initiatives.showResourecePane(null);
      dispatch.initiatives.splitAt("60%");
    }

  }



  filterColor = (data) => {
    let currentColor = colors.join(',').split(',');
    let relatedCommunity = this.props.selectedPracticeLibrary.communities;


    if (relatedCommunity.length > 0) {
      for (let i = 0; i < relatedCommunity.length; i++) {
        let colorIndex = currentColor.indexOf(relatedCommunity[i].tagColor);

        if (colorIndex !== -1) {
          currentColor.splice(colorIndex, 1)
        }

        if (relatedCommunity[i].communities.length > 0) {

          for (let j = 0; j < relatedCommunity[i].communities.length; j++) {
            let colorIndex = currentColor.indexOf(relatedCommunity[i].communities[j].tagColor);

            if (colorIndex !== -1) {
              currentColor.splice(colorIndex, 1)
            }
          }
        }
      }
    }
  }


  dataChanged = (event, data) => {
    if (event.message.length < 127) {
      const updatedName = event.message;
      const nodeToAdd = {
        _id: data.id,
        id: data.id,
        name: updatedName,
        description: "New Phase",
        initiativeId: this.props.selectedPracticeLibrary._id,
        lastUpdatedBy: this.props.user
      };
      this.props.updateAction(nodeToAdd);

    } else {
      toastr.error('Message', 'Character Max limit is 128.')

    }



  };
  inputValidation(text, id) {
    return true;

  }

  handleAdd = (e, data) => {

    let parentId;
    let treeData = this.props.selectedPracticeLibrary[this.props.elements];
    const element = this.props.elements;

    let currentColor = colors.join(',').split(',');
    let relatedCommunity = this.props.selectedPracticeLibrary.communities;


    if (relatedCommunity.length > 0) {
      for (let i = 0; i < relatedCommunity.length; i++) {
        let colorIndex = currentColor.indexOf(relatedCommunity[i].tagColor);

        if (colorIndex !== -1) {
          currentColor.splice(colorIndex, 1)
        }

        if (relatedCommunity[i].communities.length > 0) {

          for (let j = 0; j < relatedCommunity[i].communities.length; j++) {
            let colorIndex = currentColor.indexOf(relatedCommunity[i].communities[j].tagColor);

            if (colorIndex !== -1) {
              currentColor.splice(colorIndex, 1)
            }
          }
        }
      }
    }

    const addToDataNode = function (treeData, id) {
      parentId = id;
      treeData.forEach(function (treeNode) {
        if (treeNode.id === id) {
          if (!treeNode[element]) {
            treeNode[element] = [];
          }
          treeNode[element].push({
            name: (this.props.elements === 'activities' ? "Stage - " + new Date().getTime() : "New Sub Community")
          });
        } else {
          if (treeNode[element] && treeNode[element].length) {
            addToDataNode(treeNode[element], id);
          }
        }
      });
    }.bind(this);
    addToDataNode(treeData, data.id);
    const nodeToAdd = {
      name: (this.props.elements === 'activities' ? "Stage - " + new Date().getTime() : "New Sub Community"),
      description: (this.props.elements === 'activities' ? "Stage - " + new Date().getTime() : "New Sub Community"),
      initiativeId: this.props.selectedPracticeLibrary._id,
      lastUpdatedBy: this.props.user,
      tagColor: currentColor[Math.floor(Math.random() * currentColor.length)],
      isParentNode: true,
      accountId: this.props.selectedPracticeLibrary.accountId,
      organizationId: this.props.selectedPracticeLibrary.organizationId
    };
    if (this.props.elements === 'activities') {
      nodeToAdd.parentActivity = parentId;
    }
    else if (this.props.elements === 'communities') {
      nodeToAdd.parentCommunity = parentId;
    }

    this.props.addAction(nodeToAdd);
    e.stopPropagation();
  };


  handlePeer = (e, data) => {

    let treeData = this.props.selectedPracticeLibrary[this.props.elements];
    const element = this.props.elements;
    const getParentNode = function (treeData, parentId, childId) {
      for (let index = 0; index < treeData.length; index++) {
        let treeNode = treeData[index];
        const currentNodeId = treeNode._id;
        if (currentNodeId.toString() === childId.toString()) {
          return { parentId, index };
        } else {
          if (treeNode[element] && treeNode[element].length) {
            const result = getParentNode(
              treeNode[element],
              currentNodeId,
              childId
            );
            if (result) {
              return result;
            }
          }
        }
      }
    };

    const addDataNodeToParent = function (treeData, parentId, dataNode) {
      if (parentId === "root") {
        treeData.push(dataNode);
      } else {
        treeData.forEach(function (treeNode) {
          if (treeNode.id === parentId) {
            treeNode[this.props.elements].push(dataNode);
          } else {
            if (treeNode[this.props.elements] && treeNode[this.props.elements].length) {
              addDataNodeToParent(treeNode[this.props.elements], parentId, dataNode);
            }
          }
        });
      }
    };

    const targetNodeData = getParentNode(treeData, "root", data.id);
    // START-----------------------------------------------------------
    const nodeToAdd = {
      name: (this.props.elements === 'activities' ? "Phase " : "Community ") + (this.props.selectedPracticeLibrary[this.props.elements].length + 1),
      description: (this.props.elements === 'activities' ? "Phase " : "Community ") + (this.props.selectedPracticeLibrary[this.props.elements].length + 1),
      initiativeId: this.props.selectedPracticeLibrary._id,
      tagColor: "#ffffff",
      lastUpdatedBy: this.props.user,
      isParentNode: true,
      duration: 1
    };
    dispatch.initiatives.addPhaseModalOpen(true);
    //END-----------------------------------------------------------------
    e.stopPropagation()
  };

  handleDelete = (e, data) => {
    e.stopPropagation();
    const element = this.props.elements;
    const deleteDataNode = function (treeData, id) {
      for (let i = treeData.length - 1; i >= 0; i--) {
        let treeNode = treeData[i];
        if (treeNode.id === id) {

          treeData.splice(i, 1);
          return;
        } else {
          if (treeNode[element] && treeNode[element].length) {
            deleteDataNode(treeNode[element], id);
          }
        }
      }
    };
    let elementName = ""
    let errorMessage = "";
    if (element === "activities") {
      elementName = "Activity"
      errorMessage = "When deleting activity, if child activities exists, they will be deleted. Are you sure you want to proceed?"
    } else if (element === "communities") {
      elementName = "Community"
      errorMessage = "When deleting community, if child communities exists, they will be deleted. Are you sure you want to proceed?"
    } else {
      errorMessage = ""
    }



    if (e) {
      toastr.confirm(errorMessage, {
        onOk: () => {
          this.props.deleteAction({
            initiativeId: this.props.selectedPracticeLibrary._id,
            id: data.id
          });
          toastr.success('Message', elementName + ' removed successfully.')
          dispatch.app.setCollapsedResourcePaneIndexTemp(null)
          dispatch.initiatives.showResourecePane(null);
          dispatch.initiatives.setSelectedActivityData({});
        }
      });
    }
    else {
      this.props.deleteAction({
        initiativeId: this.props.selectedPracticeLibrary._id,
        id: data.id
      });
      dispatch.app.setCollapsedResourcePaneIndexTemp(null)
      dispatch.initiatives.showResourecePane(null);
      dispatch.initiatives.setSelectedActivityData({});
    }
    deleteDataNode(treeData, data.id);

  };

  addDependency(e, card) {

    if (this.props.enableDependencyIcon && this.props.selectedActivityData._id !== card._id) {
      let dependencyIndex = this.props.selectedActivityData.dependencies.indexOf(card._id);
      if (dependencyIndex === -1) {
        this.props.selectedActivityData.dependencies.push(card._id);
        if (card.runStatus != 2) {
          this.props.selectedActivityData.runStatus = -1;
        }
        if (this.props.selectedActivityData.onHoldFlag == false && card.onHoldFlag == true) {
          this.props.selectedActivityData.onHoldFlag = true;
        }
        dispatch.initiatives.editActivityAsync(this.props.selectedActivityData);
      }
    }
    e.stopPropagation();
  }
  removeDependency = (dependency) => {
    if (this.props.enableDependencyIcon && this.props.selectedActivityData._id !== dependency._id) {
      let dependencyIndex = this.props.selectedActivityData.dependencies.indexOf(dependency._id);
      if (dependencyIndex !== -1) {
        this.props.selectedActivityData.dependencies.splice(dependencyIndex, 1);
        if (this.props.selectedActivityData.dependencies.length == 0) {
          this.props.selectedActivityData.runStatus = 0;
        }
        if (this.props.selectedActivityData.onHoldFlag == true) {
          if (this.props.selectedActivityData && this.props.selectedActivityData.onHoldComments && this.props.selectedActivityData.onHoldComments.length > 0 && this.props.selectedActivityData.onHoldComments[0].isImplicitOnHold == false) {
            this.props.selectedActivityData.onHoldFlag = false;
          }
        }
        dispatch.initiatives.editActivityAsync(this.props.selectedActivityData);
      }
    }
  }

  treeDnDAction = (sourceId, targetId) => {

    if (!sourceId || sourceId.length != 24) return;

    let treeData = this.props.selectedPracticeLibrary[this.props.elements];
    const element = this.props.elements;

    const getParentNode = function (treeData, parentId, childId, depth) {
      for (let index = 0; index < treeData.length; index++) {
        let treeNode = treeData[index];
        if (treeNode) {
          const currentNodeId = treeNode._id;
          if (currentNodeId.toString() === childId.toString()) {
            // if (depth === 0)
            return { parentId, index, depth };
          } else {
            if (treeNode[element] && treeNode[element].length) {
              const result = getParentNode(
                treeNode[element],
                currentNodeId,
                childId,
                depth + 1
              );
              if (result) {
                return result;
              }
            }
          }
        }
      }
    };
    const getDataNodeById = function (treeData, id, depth) {
      for (let index = 0; index < treeData.length; index++) {
        let treeNode = treeData[index];
        if (treeNode) {
          const currentNodeId = treeNode._id;
          if (currentNodeId === id) {
            return { node: Object.assign({}, treeNode), depth };
          } else {
            if (treeNode[element] && treeNode[element].length) {
              const result = getDataNodeById(treeNode[element], id, depth + 1);
              if (result) {
                return result;
              }
            }
          }
        }
      }
    };

    const addDataNodeToParent = function (treeData, parentId, dataNode, index) {
      if (parentId === "root" || ((!dataNode.parentActivity || dataNode.parentActivity === 'root') && (!dataNode.parentCommunity || dataNode.parentCommunity === 'root'))) {
        treeData.splice(index, 0, dataNode);
      } else {

        treeData.forEach(function (treeNode) {
          if (treeNode) {
            if (treeNode._id === parentId) {
              treeNode[element].splice(index, 0, dataNode);
            } else {
              if (treeNode[element] && treeNode[element].length) {
                addDataNodeToParent(
                  treeNode[element],
                  parentId,
                  dataNode,
                  index
                );
              }
            }
          }
        });
      }
    };
    let currentParent;
    const deleteDataNodeById = function (treeData, id, parent) {
      for (let i = treeData.length - 1; i >= 0; i--) {
        let treeNode = treeData[i];
        if (treeNode) {
          if (treeNode._id === id) {
            treeData.splice(i, 1);
            currentParent = parent;


            return;
          } else {
            if (treeNode[element] && treeNode[element].length) {
              deleteDataNodeById(treeNode[element], id, treeNode._id);
            }
          }
        }
      }
    };
    const nodeCopyData = getDataNodeById(treeData, sourceId, 0);
    const targetNodeDetails = getDataNodeById(treeData, targetId, 0);

    let parentId = nodeCopyData && nodeCopyData.node.parentActivity ? nodeCopyData.node.parentActivity === 'root' ? 'root' : targetId : nodeCopyData.node.parentCommunity ? nodeCopyData.node.parentCommunity === 'root' ? 'root' : targetId : 'root';



    let targetNodeData = getParentNode(treeData, parentId, targetId, 0);

    //we should allow to drag into parent node
    if (!targetNodeDetails.node.isLeafNode && (nodeCopyData.node.isLeafNode || (nodeCopyData.node.parentActivity && nodeCopyData.node.parentActivity.length === 24))) {
      targetNodeData = { parentId, index: 0, depth: targetNodeData.depth }
    }

    const targetNodeDepth = targetNodeData.depth;

    const nodeCopy = nodeCopyData.node;
    const sorceNodeDepth = nodeCopyData.depth;
    const isPossibleToDrop = function (targetNodeDepth, sorceNodeDepth, nodeToCopy, targetNodeDetails) {

      if (targetNodeDepth === 0) {
        if ((!nodeToCopy.activities || (nodeToCopy && nodeToCopy.activities.length === 0)) && sorceNodeDepth !== 0) {
          return true;
        }
        else {
          if (sorceNodeDepth === 0) {
            return true;
          }
          else if (sorceNodeDepth === 1 && nodeToCopy.parentActivity && nodeToCopy.parentActivity.length === 24) {
            return true
          }
          else {
            return false;
          }

        }
      }
      else if (targetNodeDepth === 1) {
        if ((!nodeToCopy.activities || (nodeToCopy && nodeToCopy.activities.length === 0)) && sorceNodeDepth !== 1) {
          return true;
        }
        else {
          if (sorceNodeDepth === 1) {
            return true;
          }
          else {
            return false;
          }
        }
      }
      else if (targetNodeDepth === 2) {
        if ((!nodeToCopy.activities || (nodeToCopy && nodeToCopy.activities.length === 0))) {
          return true;
        }
        else {
          return false;
        }
      }
      else {
        return false;
      }
    }
    if (isPossibleToDrop(targetNodeDepth, sorceNodeDepth, nodeCopy)) {
      deleteDataNodeById(treeData, sourceId, 'root');
      addDataNodeToParent(
        treeData,
        targetNodeData.parentId,
        nodeCopy,
        targetNodeData.index
      );
      if (this.props.elements === 'activities') {
        nodeCopy.parentActivity = currentParent;
      } else if (this.props.elements === 'communities') {
        nodeCopy.parentCommunity = currentParent;
      }
      this.props.changeIndexAction({ nodeToMove: nodeCopy, target: targetNodeData.parentId, indexInTarget: targetNodeData.index, selectedPracticeLibrary: this.props.selectedPracticeLibrary._id });
      this.props.selectedPracticeLibrary.activities = treeData;
      dispatch.initiatives.setSelectedDataById(Object.assign({}, this.props.selectedPracticeLibrary));
    }
  };
  handleCreateActivity = (e, data) => {
    this.setState({ parentId: data.id, parentName: data.label })
    dispatch.initiatives.addActivityModalOpen(true);
    e.stopPropagation()
  };

  async onDragEnd(targetTeam, result) {
    if (result.addedIndex !== null) {
      let nodeToAdd
      nodeToAdd = {
        name: result.payload.name,
        description: result.payload.description,
        initiativeId: this.props.selectedPracticeLibrary._id,
        lastUpdatedBy: this.props.user,
        parentActivity: targetTeam._id,
        isLeafNode: true,
        duration: result.payload.duration,
        isMilestone: result.payload.isMilestone,
        accountId: this.props.selectedPracticeLibrary.accountId,
        organizationId: this.props.selectedPracticeLibrary.organizationId
      }
      if (!result.payload.initiativeId) {
        toastr.confirm(null,
          {
            okText: 'Create',
            component: () => (<div className="pad_20"><div><b className="clr-blue">Add activity under {targetTeam.name}</b><br /><br />Are you sure you wish to create activity "{result.payload.name}" under {targetTeam.name}? </div></div>),
            onOk: async () => {
              dispatch.initiatives.createActivity(nodeToAdd);
            }
          })
      }
      else {
        dispatch.initiatives.createActivity(nodeToAdd);
        this.handleDelete(null, { id: result.payload._id })
      }

    }

  }

  shouldAcceptDrop(sourceContainerOptions) {
    const accessDrop = sourceContainerOptions.groupName === 'ActivityCreation'
    return accessDrop
  }

  componentDidMount() {
    let dependentActivityArr = [];
    let leafActivityArr = [];
    let isDurationSetAllActivities = true;
    const scanForActivitiesForDurationCheck = function (treeData) {
      treeData.forEach(function (treeNode) {
        if (treeNode.isLeafNode && (!treeNode.duration || treeNode.duration === 0) && !treeNode.isMilestone) {
          isDurationSetAllActivities = false;
        }
        if (treeNode.isParentNode && treeNode.activities && treeNode.activities.length === 0) {
          leafActivityArr.push(treeNode);
        }
        if (treeNode.activities) {
          scanForActivitiesForDurationCheck(treeNode.activities);
        }

      });
    }

    scanForActivitiesForDurationCheck(this.props.selectedPracticeLibrary[this.props.elements]);
    dispatch.initiatives.isDurationSet(isDurationSetAllActivities);
    dispatch.initiatives.setDependetMilestoneAct(dependentActivityArr)
    dispatch.initiatives.setLeafAct(leafActivityArr)
  }

  componentWillMount() {
    dispatch.initiatives.setIdToCenterPosition(null);
  }

  setEditModeFalse = () => {
    this.setState({ setEditMode: false })
  }
  render() {
    let length = this.props.selectedPracticeLibrary ? this.props.selectedPracticeLibrary[this.props.elements].filter((node) => { return !node.isLeafNode }).length : '';

    let components = [];
    const thisObject = this;
    const getDataNode = function (treeData, container, depth, parent) {
      if (((depth === 1 || depth === 2) && treeData.length === 0) && parent.isParentNode) {
        container.push({
          label: <Container key={treeData.id} groupName="ActivityCreation" onDrop={async (e) => thisObject.onDragEnd(parent, e)} shouldAcceptDrop={thisObject.shouldAcceptDrop} behaviour="copy" style={{
            width: '100%', border: '1px dashed #ccc', background: "#eaeaea", padding: "5px"
          }}>Drop activity here</Container>
        });
      }
      treeData.forEach(function (treeNode, index) {
        const dataNode = {
          label: (
            <MenuNode
              key={treeNode._id}
              label={treeNode.name}
              colorTag={treeNode.tagColor}
              id={treeNode._id}
              removeDependency={thisObject.removeDependency}
              handleAdd={thisObject.handleAdd}
              handleDelete={thisObject.handleDelete}
              dataChanged={thisObject.dataChanged}
              handleDnD={thisObject.treeDnDAction}
              handlePeer={thisObject.handlePeer}
              handleCreateActivity={thisObject.handleCreateActivity}
              depth={depth}
              treeNode={treeNode}
              disabled={true}
              treeLength={length}
              validatioFunction={thisObject.inputValidation}
              status={thisObject.props.selectedPracticeLibrary.status}
              element={thisObject.props.elements}
              isParentNode={treeNode.isParentNode}
              hasActivities={treeNode.activities ? treeNode.activities.length : null}
              hasDuration={treeNode.duration ? treeNode.duration : null}
              activityRow={treeNode}
              setUniqueId={thisObject.props.setUniqueId}
              setEditMode={treeNode._id === thisObject.props.setUniqueId && thisObject.state.setEditMode}
              setEditModeFalse={thisObject.setEditModeFalse}
              getSelection={thisObject.props.getSelection}
              setCollapsedResourcePaneIndex={thisObject.props.setCollapsedResourcePaneIndex}
              dependIcon={thisObject.props.selectedActivityData
                && thisObject.props.selectedActivityData.dependencies
                && thisObject.props.selectedActivityData.dependencies.length > 0
                && thisObject.props.selectedActivityData.dependencies.indexOf(treeNode._id) != -1
                ? <Icon style={{ cursor: "auto" }} className="clr-blue" name="linkify" />
                :
                thisObject.props.enableDependencyIcon
                  && thisObject.props.selectedActivityData._id !== treeNode._id
                  && treeNode.isLeafNode
                  && thisObject.props.selectedActivityData.isLeafNode ?
                  <Icon onClick={(e) => thisObject.addDependency(e, treeNode)} style={{ cursor: "auto" }} className="clr-gray" name="linkify" />
                  : null
              }

            />
          ),
          className: thisObject.props.selectedActivityData._id === treeNode._id && selectDepth === depth ? 'activeInitiativeActivity' : '',
          raci: treeNode.raci,
          // icon: thisObject.props.selectedActivityData
          //   && thisObject.props.selectedActivityData.dependencies
          //   && thisObject.props.selectedActivityData.dependencies.length > 0
          //   && thisObject.props.selectedActivityData.dependencies.indexOf(treeNode._id) != -1
          //   ? <div style={{ width: '27px' }} ></div>
          //   : thisObject.props.enableDependencyIcon && thisObject.props.selectedActivityData._id !== treeNode._id && treeNode.isLeafNode && thisObject.props.selectedActivityData.isLeafNode ?
          //     <Icon name="linkify" onClick={(e) => thisObject.addDependency(e, treeNode)} className="dependency-color-default setDependentIcon" /> : <div style={{ width: '27px' }} ></div>
        };



        if (Array.isArray(treeNode[thisObject.props.elements]) && treeNode.isParentNode) {
          dataNode.nodes = [];
          getDataNode(treeNode[thisObject.props.elements], dataNode.nodes, depth + 1, treeNode);
        }

        container.push(dataNode);

        if (((depth === 1 || depth === 2) && index === treeData.length - 1) && parent.isParentNode) {
          container.push({
            label: <Container groupName="ActivityCreation" onDrop={async (e) => thisObject.onDragEnd(parent, e)} shouldAcceptDrop={thisObject.shouldAcceptDrop} behaviour="copy" style={{
              width: '100%', border: '1px dashed #ccc', background: "#eaeaea", padding: "5px"
            }}>Drop activity here</Container>
          });
        }
      });
    };

    getDataNode(this.props.selectedPracticeLibrary[this.props.elements], components, 0);
    let windowDimension = this.props.componentDesignerDimension;
    let designerHeight = (windowDimension.windowHeight - windowDimension.height) - 280;



    return (
      <div style={{ maxHeight: designerHeight, minHeight: designerHeight, overflow: "auto" }}>
        <TreeView

          className={`designerTree w_400 "  `}
          enableHoverStyle={false}
          dataSource={components}
          enableSelection={true}
          singleSelect={true}
          onSelectionChange={selectedMap => {
            this.onSelectionChange(selectedMap);
          }}

          defaultCollapsedDepth={2}
          enableKeyboardNavigation={false}
        />
        {
          this.props.isAddActivityModalOpen ?
            <AddActivity isAddActivityModalOpen={this.props.isAddActivityModalOpen}
              selectedActivityData={this.props.selectedActivityData}
              selectedInitiative={this.props.selectedPracticeLibrary}
              user={this.props.user}
              parentId={this.state.parentId}
              parentName={this.state.parentName}
            />
            : ''
        }

        {
          this.props.isAddPhaseModalOpen ?
            <AddPhase isAddPhaseModalOpen={this.props.isAddPhaseModalOpen}
              selectedActivityData={this.props.selectedActivityData}
              selectedDataById={this.props.selectedPracticeLibrary}
              user={this.props.user}
              RaciUserList={this.props.RaciUserList}
              newActivityObj={this.props.newActivityObj}
              addPeerBtnStatus={this.props.addPeerBtnStatus}
              communitiesMembersMap={this.props.communitiesMembersMap}
            />
            : ''
        }

      </div >

    );
  }
}

export default PracticeFlowTreePage;
